<template>
  <img :src="url" ref="el" />
</template>

<script lang="ts" setup>
import { useElementSize } from '@vueuse/core'
import { ref, computed } from 'vue'
import { getShopifyImage, ratioAsNumber } from '_library'

const props = withDefaults(
  defineProps<{
    src: string
    ratio?: string
  }>(),
  {
    // ratio: '1x1',
  }
)

const el = ref(null)
const { width: elWidth } = useElementSize(el)

const pixelRatio = typeof window !== 'undefined' ? Math.min(window.devicePixelRatio || 1, 2) : 2

const size = computed(() => {
  const ratioNumber = props?.ratio && `${props?.ratio}`.indexOf('x') > -1 && ratioAsNumber(props.ratio)

  if (elWidth.value == 0) {
    const blurWidth = 600
    return {
      width: blurWidth,
      height: ratioNumber ? ratioNumber * blurWidth : blurWidth,
    }
  } else {
    return {
      width: elWidth.value,
      height: ratioNumber ? ratioNumber * elWidth.value : elWidth.value,
    }
  }
})

const url = computed(() => {
  const { url: src } = getShopifyImage(props.src, {
    modifiers: {
      width: size.value.width * pixelRatio,
      ratio: props.ratio || '1x1',
    },
  })
  return src
})
</script>

<style lang="scss"></style>
